// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { apiConfig } from '../../../config'
import { getHeaders, ApiScope } from '../../silentAuth'
import { BacnetObjectState, BacnetObjectTypes, BacnetObjectPropertyState, EdgeDeviceDto, EdgeBacnetDeviceDto } from './types'


export type GetObjectsQueryArgs = {
    edgeDeviceId: string,
    deviceId: number,
}
export type ReprocessMappingArgs = {
  edgeDeviceId: string,
  deviceId: number,
  bacnetObjectType: number,
  bacnetInstanceId: number
}

export type GetObjectPropertiesQueryArgs = {
    edgeDeviceId: string,
    deviceId: number,
    objectType: BacnetObjectTypes,
    instanceId: number
}

// Define a service using a base URL and expected endpoints
export const bacnetStateApi = createApi({
  reducerPath: 'bacnetStateApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiConfig.bacnetStateApi,
    prepareHeaders: async (headers, { getState }) => { return await getHeaders(ApiScope, headers); }
  }),
  tagTypes: ['BacnetState', 'EdgeDevices', 'BacnetDevices'],
  endpoints: (builder) => ({
    getObjects: builder.query<BacnetObjectState[], GetObjectsQueryArgs>({
      query: ({ edgeDeviceId, deviceId }) => `/${edgeDeviceId}/${deviceId}/objects`,
      providesTags: ['BacnetState'],
    }),
    getObjectProperties: builder.query<BacnetObjectPropertyState[], GetObjectPropertiesQueryArgs>({
        query: ({ edgeDeviceId, deviceId, objectType, instanceId }) => `/${edgeDeviceId}/${deviceId}/objects/${objectType}/${instanceId}`,
        providesTags: ['BacnetState'],
      }),
      getEdgeDevices: builder.query<EdgeDeviceDto[], void>({
        query: () => `/`,
        providesTags: ['EdgeDevices'],
      }),
      getBacnetDevices: builder.query<EdgeBacnetDeviceDto[], string>({
        query: (edgeDeviceId ) => `/${edgeDeviceId}`,
        providesTags: ['BacnetDevices'],
      }),
      reprocessMappings: builder.mutation<string, ReprocessMappingArgs>({
        query: ({edgeDeviceId, deviceId, bacnetInstanceId, bacnetObjectType}) => ({
          url:  `/${edgeDeviceId}/${deviceId}/objects/${bacnetObjectType}/${bacnetInstanceId}/reprocess`,
          method: 'post',
          responseHandler: (response) => response.text(), 
        })
      }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetObjectsQuery,
  useGetObjectPropertiesQuery,
  useGetEdgeDevicesQuery,
  useGetBacnetDevicesQuery,
  useReprocessMappingsMutation

} = bacnetStateApi